import { render, staticRenderFns } from "./leadsDashboardSettings.vue?vue&type=template&id=5f9b46b5&scoped=true"
import script from "./leadsDashboardSettings.vue?vue&type=script&lang=js"
export * from "./leadsDashboardSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b46b5",
  null
  
)

export default component.exports